import { Table, Button, Tag, Select, DatePicker, Row, Col } from 'antd/lib';
import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import { imprimirReporteEnvio } from '../../common/funciones/imprimirReporte';
import {
  FaThumbsUp,
  FaThumbsDown,
  FaCheck,
  FaPrint,
  FaEye,
  FaTrash,
} from 'react-icons/fa';
import { Pagination } from 'antd';

const { RangePicker } = DatePicker;

class TablaIngresos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.certificaciones,
      textoBuscarNombre: '',
      textoBuscarApellido: '',
      textoBuscarDocumento: '',
      filtered: false,
    };
  }

  onInputChange = e => {
    this.setState({ textoBuscarNombre: e.target.value });
  };

  onApellidoChange = e => {
    this.setState({ textoBuscarApellido: e.target.value });
  };

  onDocumentoChange = e => {
    this.setState({ textoBuscarDocumento: e.target.value });
  };

  descargar = () => {
    this.props.onDescargar();
  };

  render() {
    let fGeneracion = moment(new Date()).format('DD/MM/YYYY HH:mm');

    // console.log('PROPS QUE TENGO: ', this.props);
    const { envios, usuario, organismos } = this.props;

    const columns = [
      {
        title: 'N°',
        dataIndex: 'numero',
        key: 'numero',
        render: numero => <p style={{ fontSize: 12 }}> {numero} </p>,
        align: 'center',
      },
      {
        title: 'Fecha Envio',
        key: 'fechaEnvio',
        render: record => (
          <p style={{ fontSize: 12 }}>
            {record.fechaEnvio
              ? moment(record.fechaEnvio).format('DD/MM/YYYY')
              : 'SIN DATOS'}{' '}
          </p>
        ),
        align: 'center',
      },
      {
        title: 'Fecha Arrivo',
        key: 'fechaArrivo',
        render: record => (
          <p style={{ fontSize: 12 }}>
            {record.fechaArrivo
              ? moment(record.fechaArrivo).format('DD/MM/YYYY')
              : 'SIN DATOS'}{' '}
          </p>
        ),
        align: 'center',
      },
      {
        title: (
          <div>
            <Col span={4}> {'Tasa'} </Col>
            <Col span={4}> {'Cant'} </Col>
            <Col span={8}> {'N° Incial'} </Col>
            <Col span={8}> {'N° Final'} </Col>
          </div>
        ),
        dataIndex: 'detalle',
        key: 'detalle',
        width: 300,
        render: detalle => (
          <div key={Math.random() * (1000000 - 0) + 0}>
            {_.map(detalle, detail => (
              <Row key={Math.random() * (1000000 - 0) + 0}>
                <Col span={4}>
                  {' '}
                  <p style={{ fontSize: 11 }}>
                    {' '}
                    ${detail.tipo_sello.valor}:{' '}
                  </p>{' '}
                </Col>
                <Col span={4}>
                  {' '}
                  <p style={{ fontSize: 11 }}> {detail.cantidad}</p>{' '}
                </Col>
                <Col span={8}>
                  {' '}
                  <p style={{ fontSize: 11 }}> {detail.numeracionInicial}°</p>
                </Col>
                <Col span={8}>
                  {' '}
                  <p style={{ fontSize: 11 }}> {detail.numeracionFinal}° </p>
                </Col>
              </Row>
            ))}
          </div>
        ),
        align: 'center',
      },
      {
        title: 'Importe',
        dataIndex: 'importe',
        key: 'importe',
        render: importe => (
          <p style={{ fontSize: 11 }}>
            {' '}
            {importe.toLocaleString('es-AR', {
              style: 'currency',
              currency: 'ARS',
            })}{' '}
          </p>
        ),
        align: 'center',
      },
      {
        title: 'Estado',
        key: 'estado',
        dataIndex: 'estado',
        render: estado => {
          switch (estado) {
            case 'PENDIENTE':
              return (
                <Tag key={estado} color="blue">
                  <p style={{ fontSize: 11 }}> PENDIENTE </p>
                </Tag>
              );
            case 'EN CAMINO':
              return (
                <Tag key={estado} color="orange">
                  <p style={{ fontSize: 11 }}> EN CAMINO </p>
                </Tag>
              );
            case 'EN DESTINO':
              return (
                <Tag key={estado} color="green">
                  <p style={{ fontSize: 11 }}> EN DESTINO </p>
                </Tag>
              );
          }
        },
        align: 'center',
      },
      {
        title: 'Remitente',
        key: 'remitente',
        dataIndex: 'remitente',
        render: remitente => (
          <p style={{ fontSize: 12 }}> {remitente.nombre} </p>
        ),
        align: 'center',
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            {record.estado == 'EN CAMINO' &&
              (usuario.organismo._id == record.receptor._id ||
                usuario.organismo._id == '00004') && (
                <Button
                  size="small"
                  style={{ marginLeft: 5 }}
                  onClick={() =>
                    this.props.history.push(
                      `/administracionGeneral/ingresos/confirmar/${record._id}`
                    )
                  }
                >
                  <span>
                    <FaCheck />
                  </span>
                </Button>
              )}
            {record.estado == 'PENDIENTE' &&
              (usuario.rol == 'ADMINISTRADOR' ||
                usuario.rol == 'OPERADOR' ||
                usuario.rol == 'SUPERVISOR') && (
                <Button
                  size="small"
                  style={{ marginLeft: 5 }}
                  onClick={() => this.props.aprobarEnvio(record._id)}
                >
                  <span>
                    <FaThumbsUp />
                  </span>
                </Button>
              )}
            {record.estado == 'PENDIENTE' &&
              (usuario.rol == 'ADMINISTRADOR' ||
                usuario.rol == 'OPERADOR' ||
                usuario.rol == 'SUPERVISOR') && (
                <Button
                  size="small"
                  style={{ marginLeft: 5 }}
                  onClick={() => this.props.desaprobarEnvio(record._id)}
                >
                  <span>
                    <FaThumbsDown />
                  </span>
                </Button>
              )}
            <Button
              size="small"
              style={{ marginLeft: 5 }}
              type="primary"
              onClick={() => imprimirReporteEnvio(fGeneracion, record)}
            >
              <span>
                <FaPrint />
              </span>
            </Button>
            <Button
              size="small"
              style={{ marginLeft: 5 }}
              disabled={!record.pedido || !record.pedido._id}
              type="primary"
              onClick={() => this.props.mostrarModalVerPedido(record)}
            >
              <span>
                <FaEye />
              </span>
            </Button>
            <Button
              size="small"
              style={{ marginLeft: 5 }}
              type="danger"
              onClick={() => this.props.onDelete(record._id)}
            >
              <span>
                <FaTrash />
              </span>
            </Button>
          </span>
        ),
        align: 'center',
      },
    ];

    const pagination = {
      onChange: page => {
        this.props.cambiarPagina(page);
      },
      total: this.props.total,
      current: this.props.pagina,
      pageSize: this.props.cantidadPorPagina,
      showSizeChanger: true,
      pageSizeOptions: ['2', '5', '10', '20', '50'],
      onShowSizeChange: (current, pageSize) => {
        this.props.cambiarTamañoPagina(pageSize);
        this.props.cambiarPagina(1);
      },
    };

    return (
      <Table
        rowKey="_id"
        columns={columns}
        pagination={pagination}
        dataSource={envios}
        style={{ textAlign: 'center' }}
        size="small"
        // className="gilada"
        loading={this.props.cargando}
        title={() => (
          <div>
            <h2 style={{ textAlign: 'center' }}> Tabla de Envios </h2>
            <div style={{ textAlign: 'center' }}>
              <Row>
                <Col>
                  <h3>ORGANISMO RECEPTOR: </h3>
                </Col>
                <Col>
                  <Select
                    style={{ width: 500, marginLeft: 10 }}
                    id="organismos"
                    placeholder="Seleccione el organismo"
                    // defaultValue={
                    //   this.props.filtroOrganismo && this.props.filtroOrganismo.length > 0
                    //     ? this.props.filtroOrganismo
                    //     : usuario.organismo.nombre
                    // }
                    value={this.props.filtroOrganismo}
                    disabled={usuario.organismo._id != '00004'}
                    onSelect={valor => this.props.cambiarOrganismo(valor)}
                  >
                    {organismos &&
                      organismos.map(organismo => (
                        <Select.Option
                          key={organismo._id}
                          value={organismo._id}
                        >
                          {organismo.nombre}
                        </Select.Option>
                      ))}
                  </Select>
                </Col>
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col>
                  <h3>FECHAS:</h3>
                </Col>
                <Col>
                  <RangePicker
                    style={{ width: 500, marginLeft: 10 }}
                    onChange={this.props.onChange}
                    defaultValue={
                      this.props.fechaInicial && this.props.fechaFinal
                        ? [
                            moment(this.props.fechaInicial),
                            moment(this.props.fechaFinal),
                          ]
                        : [moment().subtract(7, 'd'), moment()]
                    }
                    format={'DD-MM-YYYY'}
                  />
                </Col>{' '}
              </Row>
            </div>{' '}
          </div>
        )}
        locale={{
          emptyText: 'Sin datos de envios.',
        }}
      />
    );
  }
}

export default TablaIngresos;
